var React = require('react');

function Telegram (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"telegram","d":"M18.49,20.325,20.776,9.548a1.026,1.026,0,0,0-.163-.98.708.708,0,0,0-.8-.109L6.376,13.638a1.363,1.363,0,0,0-.615.389.335.335,0,0,0-.039.412.85.85,0,0,0,.5.3l3.437,1.073,7.978-5.023q.327-.218.5-.094.109.077-.062.233l-6.454,5.831-.248,3.545a1,1,0,0,0,.7-.342l1.68-1.617,3.483,2.566q1,.56,1.259-.591Zm9.377-6.392a13.624,13.624,0,0,1-1.1,5.412,13.688,13.688,0,0,1-7.418,7.418,13.817,13.817,0,0,1-10.823,0A13.688,13.688,0,0,1,1.1,19.345a13.817,13.817,0,0,1,0-10.823A13.688,13.688,0,0,1,8.522,1.1a13.817,13.817,0,0,1,10.823,0,13.688,13.688,0,0,1,7.418,7.418A13.624,13.624,0,0,1,27.867,13.933Z"}));
}

Telegram.defaultProps = {"width":"27.867","height":"27.867","viewBox":"0 0 27.867 27.867"};

module.exports = Telegram;

Telegram.default = Telegram;
